module.exports = __webpack_public_path__ + "img/facebook.6a3b8870.svg";